import { api } from "./api";

export type ReportType =
  | "egg-production"
  | "feed-logs"
  | "mortality"
  | "egg-sales"
  | "stock"
  | "feed-production"
  | "expenses";

export const reportService = {
  download: async (type: ReportType, from?: string, to?: string) => {
    const params: Record<string, string> = {};
    if (from) params.from = from;
    if (to) params.to = to;

    const response = await api.get(`/reports/${type}`, {
      params,
      responseType: "blob",
    });

    const blob = new Blob([response.data as BlobPart], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${type}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  },
};
